import { Container, Navbar } from 'reactstrap';

export const BottomNavBar = ({ children }) => (
    <Navbar
        tag="footer"
        container={false}
        className="p-0 shadow-lg"
    >
        <Container
            fluid
            className="justify-content-around"
        >
            {children}
        </Container>
    </Navbar>
);